/**
 * @copyright Elmelo Ltd.
 */
import React from "react";
import { Image, Button, Row, Col, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import * as actions from "../../rdx/actions";
import NavHdr from "../_common/nav_hdr";
import color from "../_common/colors.json";
import "../../css/_common.css";
import Address_Details from "./address";
import Card_Details from "./card";
import Order_History from "./orderHistory";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneVolume, faMapMarked, faCreditCard, faUtensils, faTimes, faPowerOff, faClock } from "@fortawesome/free-solid-svg-icons";
import { Core } from "../../api";
import { SignOut } from "../auth/sign_out";
import { navigate } from "@reach/router";
import { Profile_Head, Details_Box, Name, Email, ProImage } from "./_common";
import ContentLoader from "react-content-loader";
import * as dotenv from "dotenv";
dotenv.config();

class Profile_Home extends React.PureComponent {
	/**
	 */
	// constructor( props )
	// {
	//     super( props )
	// }

	/**
	 */
	render() {
		return (
			<div>
				<NavHdr profile={true} />
				<Profile_Header {...this.state} {...this.props} />
				<Profile_Body {...this.props} />
			</div>
		);
	}
} // class Profile_Home

class Profile_Header extends React.PureComponent {
	/**
	 */
	constructor(props) {
		super(props);
		this.state = {
			b_load: true,
			title: "",
			first: "",
			last: "",
			username: "",
			email: "",
			edit_email: ""
		};
	}

	/**
	 */
	render() {
		return (
			<div>
				{this.state.b_load ? (
					<ContentLoader height={160} width={200} speed={1} primaryColor="#f3f3f3" secondaryColor="#ecebeb">
						<rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
						<rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
						<rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
						<rect x="0" y="65" rx="4" ry="4" width="400" height="10" />
						<rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
						<rect x="0" y="99" rx="5" ry="5" width="400" height="200" />
					</ContentLoader>
				) : (
					<div className="screenWrapper">
						<div className="profileContainer">
							<ProImage {...this.state} />
							<div className="infoDetails">
								<Name {...this.state} {...this.props} onChange={(key, val) => this.setState({ [key]: val })} editName={this.editName} SaveName={() => this.SaveName()} />
								<Email {...this.state} {...this.props} onChange={(key, val) => this.setState({ [key]: val })} emailEdit={this.emailEdit} SaveEmail={() => this.SaveEmail()} />
							</div>

							<div className="infoDetails">
								<div className="infoContact" style={{ color: color.colors.light }}>
									<FontAwesomeIcon style={{ marginRight: 16 }} icon={faPhoneVolume} size="sm" />
									{this.state.phone ? this.state.phone : "No phone number provided"}
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
			// <Profile_Head
			//      className="profileContainer"
			//      userName= {this.props.name}
			//      userEmail="asif.amin@gmail.com"
			//      address="John Eccles House, Robert Robinson Avenue, Oxford Science Park, Oxford, OX4 4GP, Oxford, UK"
			//      userPhone="+44 (0) 1865 922 172"
			//      img="data:image/png;base64,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"
			//  />
		);
	}
	/**
	 */
	editName = () => {
		this.setState({
			title: this.state.username.title,
			first: this.state.username.first,
			last: this.state.username.last
		});
	};
	/**
	 */
	emailEdit = () => {
		this.setState({ edit_email: this.state.email });
	};
	/**
	 */
	Init = async () => {
		try {
			const aws_core = new Core({});

			const tmp_name = await aws_core.Name();

			const tmp_email = await aws_core.Email();

			const tmp_number = await aws_core.Phone();

			this.setState({
				b_load: false,
				title: tmp_name.title,
				first: tmp_name.first,
				last: tmp_name.last,
				username: tmp_name,
				email: tmp_email.addr ? tmp_email.addr : "",
				phone: tmp_number.number
			});
		} catch (err) {
			console.warn("ProfileName: Init: err: ", err);
			// stop the loading placeholder (e.g. guests, network errors)
			this.setState({ b_load: false });
			return Promise.reject(err);
		}
	};

	/**
	 */
	componentDidMount() {
		this.Init()
			.then(data => {})
			.catch(err => {});
	}
	/**
	 */
	SaveName = async () => {
		try {
			const cfg = this.props.__cfg;

			const aws_core = new Core({});

			const new_name = { first: this.state.first, last: this.state.last };

			await aws_core.SetName(new_name);
			//
			this.setState({ username: new_name });

			// save to public info
			// const aws_lambda = new Lambda( {} );
			//
			// const p_lambda = {
			//     actType: 'social'
			//     ,   act: 'public:setinfo_profname'
			//     ,	prof_name: new_name_str
			//     ,	stage: cfg.stage
			//     ,   usr: 'beta'
			// };
			// const resp_lambda = await aws_lambda.Invoke( p_lambda, cfg.lambda.beta );
			//
			// if( resp_lambda.errorMessage )
			//     throw new Error( resp_lambda.errorMessage )
			// return {msg: 'OK'}
		} catch (err) {
			console.warn("ProfileEmail: Save: err: ", err);
			return { err };
		}
	};
	/**
	 */
	SaveEmail = async () => {
		try {
			const aws_core = new Core({});

			await aws_core.SetEmail(this.state.edit_email);

			// const email_obj = aws_core.Email()

			// if(!email_obj.bVerified)
			//     this.setState({email_b_t: true })

			this.setState({ email: this.state.edit_email });
		} catch (err) {
			console.warn("ProfileEmail: Save: err: ", err);
			return { err };
		}
	};
}
class Profile_Body extends React.PureComponent {
	/**
	 */
	constructor(props) {
		super(props);
		this.state = {
			orderHistory: false,
			addressDetails: true,
			cardDetails: false
		};
	}
	logout = async () => {
		// clears the previous user's chat id, channel, cart ... (a client-side navigate kept them)
		await SignOut();
	};
	/**
	 */
	render() {
		return (
			<div className="screenWrapper">
				<div className="profileBody">
					<div className="profileBodyItems">
						{/* <Details_Box
							activeItem={() =>
								this.setState({
									orderHistory: true,
									addressDetails: false,
									cardDetails: false
								})
							}
							style={{
								color: this.state.orderHistory ? "#fff" : null,
								backgroundColor: this.state.orderHistory ? this.props.__biz.site_settings.base.colors.primary : null
							}}
							icon={faUtensils}
							title="Order History"
							active={this.state.orderHistory}
						/> */}
						<Details_Box
							activeItem={() =>
								this.setState({
									orderHistory: false,
									addressDetails: true,
									cardDetails: false
								})
							}
							style={{
								color: this.state.addressDetails ? "#fff" : null,
								backgroundColor: this.state.addressDetails ? this.props.__biz.site_settings.base.colors.primary : null
							}}
							icon={faMapMarked}
							title="Address Details"
							active={this.state.addressDetails}
						/>
						<Details_Box
							activeItem={() =>
								this.setState({
									orderHistory: false,
									addressDetails: false,
									cardDetails: true
								})
							}
							style={{
								color: this.state.cardDetails ? "#fff" : null,
								backgroundColor: this.state.cardDetails ? this.props.__biz.site_settings.base.colors.primary : null
							}}
							icon={faCreditCard}
							title="Card Details"
							active={this.state.cardDetails}
						/>
						<Details_Box activeItem={() => this.logout()} icon={faPowerOff} title="Logout" />
					</div>
					<div style={{ flex: 1 }}>{this.state.orderHistory ? <Order_History {...this.props} /> : this.state.addressDetails ? <Address_Details /> : <Card_Details />}</div>
				</div>
			</div>
		);
	}

	/**
	 */
	componentDidMount() {}
}

/**
 */
const mapStateToProps = state => {
	return state;
}; //

/**
 */
export default connect(mapStateToProps, actions)(Profile_Home);
